import { useState } from "react";

/**
 * Shared client-side pagination for record lists (Waste, Chemical, …).
 *
 * `goToLastPageAfterAdd`/`clampAfterRemove` read `records.length` at call
 * time — i.e. BEFORE the parent's state update lands — so they compute the
 * next page from the record count as it will be immediately after the
 * add/remove, matching the arithmetic every section already hand-rolled.
 */
export const usePaginatedRecords = <T,>(records: T[], perPage: number) => {
  const [page, setPage] = useState(1);

  const totalPages = Math.ceil(records.length / perPage);
  const offset = (page - 1) * perPage;
  const paginated = records.slice(offset, offset + perPage);

  const goToLastPageAfterAdd = () => setPage(Math.ceil((records.length + 1) / perPage));

  const clampAfterRemove = () => {
    const nextTotalPages = Math.ceil((records.length - 1) / perPage);
    if (page > nextTotalPages && nextTotalPages > 0) setPage(nextTotalPages);
  };

  return { page, setPage, totalPages, paginated, offset, goToLastPageAfterAdd, clampAfterRemove };
};
